import create from 'zustand';

interface ISoftLoadState {
  readonly isSoftLoadEnabled?: boolean;
  readonly setIsSoftLoadEnabled: (isSoftLoadEnabled: boolean) => void;
}

const useSoftLoadStore = create<ISoftLoadState>((set) => ({
  isSoftLoadEnabled: undefined,
  setIsSoftLoadEnabled: (isSoftLoadEnabled: boolean) =>
    set({ isSoftLoadEnabled }),
}));

export default useSoftLoadStore;
